import React, { useRef } from 'react';
import ImageLazy from './ImageLazy';
import { Image } from '@sitecore-jss/sitecore-jss-react';

var ImageLoader = function ImageLoader(props) {
  var _props$isEditing = props.isEditing,
      isEditing = _props$isEditing === void 0 ? false : _props$isEditing,
      _props$media = props.media,
      media = _props$media === void 0 ? {} : _props$media,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$loadEagerly = props.loadEagerly,
      loadEagerly = _props$loadEagerly === void 0 ? false : _props$loadEagerly,
      _props$type = props.type,
      type = _props$type === void 0 ? {} : _props$type;
  var ref = useRef();

  if (isEditing) {
    return /*#__PURE__*/React.createElement(Image, {
      media: media,
      className: className
    });
  }

  ;

  if (!(media === null || media === void 0 ? void 0 : media.value)) {
    return /*#__PURE__*/React.createElement("div", null);
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      ref: ref
    }), /*#__PURE__*/React.createElement(ImageLazy, {
      media: media,
      className: className,
      loadEagerly: loadEagerly,
      type: type,
      myRef: ref
    }));
  }
};

export default ImageLoader;